export const ROUTES = {
  HOME: '/',
  APP: '/app',
  LOGIN: '/login',
  INTERNAL_SERVICES: '/services',
  EXTERNAL_SERVICES: '/external-services',
  PERSONAL_DATA: '/personal_data',
  USER: {
    APP_SETTINGS: '/user/app-settings',
    PROFILE: '/user/profile',
    REQUESTS: {
      ACTIVE_REQUESTS: '/user/requests/active',
      ARCHIVED_REQUESTS: '/user/requests/archived',
      DRAFT_REQUESTS: '/user/requests/draft',
    },
  },
  ABOUT_APP: '/about_app',
  GERC_REDIRECT: '/gerc_redirect',
  DIIA_REDIRECT: '/diia_redirect',
  MAP: '/map',
};
